import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const devicesJourneyRoutes = [
  {
    id: 'devices-list',
    trackingName: 'Devices List',
    path: 'dl/view/device-manager/device-list',
    lazy: async () => ({
      Component: (await import('../components/JourneyDeviceList')).JourneyDeviceList,
    }),
  },
  {
    id: 'devices-device',
    trackingName: 'Devices Device Details',
    path: 'dl/view/device-manager/device-details/:hashedAppToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyDeviceDetails')).JourneyDeviceDetails,
    }),
  },
  {
    id: 'devices-device-removal-confirmation',
    trackingName: 'Devices Device Removal Confirmation',
    path: 'web/view/device-manager/remove-all',
    lazy: async () => ({
      Component: (await import('../components/JourneyDevicesRemovalConfirmation')).JourneyDevicesRemovalConfirmation,
    }),
  },
  {
    id: 'devices-device-removed',
    trackingName: 'Devices Device Removed',
    path: 'web/view/device-manager/device-removed',
    lazy: async () => ({
      Component: (await import('../components/JourneyDeviceRemoved')).JourneyDeviceRemoved,
    }),
  },
  {
    id: 'devices-device-error',
    trackingName: 'Devices Device Error',
    path: 'web/view/device-manager/error',
    lazy: async () => ({
      Component: (await import('../components/JourneyDevicesError')).JourneyDevicesError,
    }),
  },
] as const satisfies JourneyRoute[]
